import React from "react";
import DevTable from "./DevTable";
import { STATUSES, STATUS_ORDER } from "../lib/constants";

function buildGroups(devs, groupBy) {
  if (groupBy === "status") {
    return STATUS_ORDER
      .map((s) => ({ key: s, label: STATUSES[s].label, items: devs.filter((d) => d.status === s) }))
      .filter((g) => g.items.length > 0);
  }
  if (groupBy === "responsable") {
    const map = new Map();
    const noResp = [];
    devs.forEach((d) => {
      const resps = d.responsables || [];
      if (resps.length === 0) { noResp.push(d); return; }
      resps.forEach((r) => {
        if (!map.has(r.id)) map.set(r.id, { key: r.id, label: r.name, items: [] });
        map.get(r.id).items.push(d);
      });
    });
    const groups = Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
    if (noResp.length > 0) groups.push({ key: "__none__", label: "Sin asignar", items: noResp });
    return groups;
  }
  if (groupBy === "solicitante" || groupBy === "departamento_solicitante") {
    const map = new Map();
    devs.forEach((d) => {
      const key = (d[groupBy] || "").trim() || "__none__";
      if (!map.has(key)) map.set(key, { key, label: key === "__none__" ? "Sin especificar" : key, items: [] });
      map.get(key).items.push(d);
    });
    return Array.from(map.values()).sort((a, b) => (a.key === "__none__" ? 1 : b.key === "__none__" ? -1 : a.label.localeCompare(b.label)));
  }
  return null;
}

export default function GroupedDevTable({ devs, groupBy, ...tableProps }) {
  const groups = buildGroups(devs, groupBy);
  if (!groups) return <DevTable devs={devs} {...tableProps} />;

  if (groups.length === 0) {
    return <div className="border border-border bg-white rounded-sm px-4 py-10 text-center text-slate-400 text-sm">No hay desarrollos.</div>;
  }

  return (
    <div className="space-y-6" data-testid="grouped-dev-table">
      {groups.map((g) => (
        <div key={g.key} data-testid={`group-${g.key}`}>
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-sm font-bold tracking-tight text-slate-800">{g.label}</h3>
            <span className="font-mono text-xs bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-sm">{g.items.length}</span>
          </div>
          <DevTable devs={g.items} {...tableProps} />
        </div>
      ))}
    </div>
  );
}
